import { CallbotTask } from '@/types/callbot'

/**
 * Форматтеры задач вынесены из Callbot.vue, чтобы карточка клиента в
 * сайдбаре показывала ровно те же подписи, что и строка в списке.
 */
export function formatTaskPhone(phone: string): string {
    const digits = String(phone || '').replace(/\D/g, '')
    if (digits.length !== 11) return phone
    return `+${digits[0]} ${digits.slice(1, 4)} ${digits.slice(4, 7)}-${digits.slice(
        7,
        9
    )}-${digits.slice(9)}`
}

export function taskStatusLabel(task: CallbotTask): string {
    if (task.group === 'recorded') return 'Записан'
    if (task.group === 'deferred') return 'Отложено администратором'
    if (task.group === 'do_not_call') {
        return task.result === 'pressed_2' ? 'Нажал 3' : 'Исключён администратором'
    }
    return task.transferConnected
        ? 'Разговор с администратором состоялся'
        : 'Администратор не ответил'
}

export function attemptResultLabel(result: string | null): string {
    if (!result) return 'Без результата'
    return (
        {
            pressed_1: 'Нажал 5 — тёплый лид',
            pressed_2: 'Нажал 3 — больше не звонить',
            no_answer: 'Не дозвонились',
            voicemail: 'Автоответчик',
            hangup_no_input: 'Ответил без выбора',
            provider_error: 'Ошибка телефонии',
        }[result] || result
    )
}
